import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">实时快讯</h2>
          <p className="text-foreground-500 text-sm md:text-base">最新瓜田动态，滚动更新不停歇</p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updatesData.map((item, i) => (
            <div
              key={item.id}
              className="relative pl-8 pb-8 last:pb-0 animate-fade-in-up"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="absolute left-0 top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
              {i < updatesData.length - 1 && (
                <div className="absolute left-[5px] top-4 bottom-0 w-0.5 bg-background-300"></div>
              )}
              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="text-xs text-foreground-400 font-medium">{item.time}</span>
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold 
                    ${item.tag === '最新' || item.tag === '突发' ? 'bg-primary-100 text-primary-700' : ''}
                    ${item.tag === '独家' || item.tag === '内幕' ? 'bg-accent-100 text-accent-700' : ''}
                    ${item.tag === '热点' || item.tag === '热议' ? 'bg-primary-50 text-primary-600' : ''}
                    ${item.tag === '跟进' || item.tag === '官方' ? 'bg-secondary-100 text-secondary-700' : ''}
                    ${item.tag === '数据' ? 'bg-background-200 text-foreground-600' : ''}
                  `}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-foreground-800 text-sm md:text-base leading-relaxed font-medium">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}